import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CecTable, CecTableAdminStatus, CecTableStatus, CecTableType} from '../../../../../types/cec-table';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-multiple-table-creator',
  templateUrl: './multiple-table-creator.component.html',
  styleUrls: ['./multiple-table-creator.component.css']
})
export class MultipleTableCreatorComponent implements OnInit {

  tableContentGroup = new UntypedFormGroup({
    tableContent: new UntypedFormControl('', Validators.required)
  });

  cecTables: CecTable[] = [];

  constructor(private dialogRef: MatDialogRef<MultipleTableCreatorComponent>) { }

  ngOnInit(): void {
  }

  /**
   * function for create and saving CecTable array
   */
  saveListOfTables(): void {
    const arrayOfTables = this.tableContentGroup.get('tableContent').value.split(' ');
    for (const table of arrayOfTables) {
      const tableName = table.replace(/[{()}]/g, '');
      this.cecTables.push(new CecTable(tableName, this.getTableType(table), CecTableAdminStatus.OK, CecTableStatus.OK, true));
    }
    this.dialogRef.close(this.cecTables);
  }

  /**
   * function for evaluation, if desired table is normal or life stamp
   * () means, that desired table is life stamp
   * @param table for evaluation of desired table
   */
  getTableType(table: string): CecTableType {
    const newTable = table.split('(');
    for (let i = 1; i < newTable.length; i++) {
      return CecTableType.LIFESTAMP;
    }
    return CecTableType.NORMAL;
  }

}
